import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MassDeposit = ({ id, association_data }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState([
    {
      index_id: 0,
      accounts: [],
      amount: [],
    },
  ]);
  const [accounts_data, setAccounts_data] = useState([]);
  const [date, setDate] = useState(dayjs());
  const [checked, setChecked] = useState(false);
  const [checked_re, setChecked_re] = useState(false);
  const [openn, setOpenn] = useState(false);
  const [done, setUndone] = useState(false);
  const [value1, setValue1] = useState(0);
  const [refund_data, setRefund_data] = useState([]);
  const [refund_accounts, setRefund_accounts] = useState([]);
  const [refund_accounts_total, setRefund_accounts_total] = useState(0);

  
  const refund_now = () => {

    const data = {
      refund_accounts: refund_accounts,
      association_id: id
    };
    toast.promise(
      api
      .post('/transactions/mass/refunding/', data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading:'Refunding...',
        success: (response) => {
          refunds_accounts_fetch();
          return response.data
        },
        error: (error) => {
          console.log(error)
          return 'An error occurred, Please try again'
        }
      }
    )
    // toast.promise(
    //   api
    //   .get(`/transactions/mass/refunding/reverse/${id}`, {
    //     headers: {
    //       Authorization: "Bearer " + fetchToken(),
    //     },
    //   }),
    //   {
    //     loading:'Refunding...',
    //     success: (response) => {
    //       refunds_accounts_fetch();
    //       return response.data
    //     },
    //     error: (error) => {
    //       console.log(error)
    //       return 'An error occurred, Please try again'
    //     }
    //   }
    // )
  }

  const viewGroup = () => {
    const stateData = {
      refund_accounts: refund_accounts,
      refund_data: refund_data,
      refund_accounts_total: refund_accounts_total,
      association_data: association_data,
      association_id: id
    };
  
    // Store the data in local storage
    localStorage.setItem('printState', JSON.stringify(stateData));
  
    // Open the new tab
    window.open('/withdrawals/print', '_blank');
  }

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleCloses = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const fetch_data = () => {
    api
      .get(`/transactions/mass/form/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  const visitMember = (member_id, member_name) => {
    navigate("/onemember/", {
      state: {
        Member_id: member_id,
        Fullname: member_name,
      },
    });
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleFormChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleFormChange_re = (event) => {
    setChecked_re(event.target.checked);
  };

  const submit = (e) => {
    e.preventDefault();
    const everything = {
      data: formFields,
      decide: checked,
      date: date,
    };
    if (done === true) {
      toast.info("Please refresh the page");
    } else {
      handleOpen();
      api
        .post("/transactions/mass/deposit/reality", everything, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          setUndone(true);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          handleCloses();
        });
    }
  };

  const addFields = () => {
    const maxIndexId = Math.max(
      ...formFields.map((field) => field.index_id),
      0
    );
    const nextIndexId = maxIndexId + 1;

    let new_object = {
      index_id: nextIndexId,
      accounts: [],
      amount: [],
    };
    setFormFields([...formFields, new_object]);
  };

  const removeField = (index_id) => {
    const indexToRemove = formFields.findIndex(
      (field) => field.index_id === index_id
    );

    if (indexToRemove !== -1) {
      const updatedFormFields = [...formFields];
      updatedFormFields.splice(indexToRemove, 1);
      setFormFields(updatedFormFields);
    }
  };

  const fetch_accounts_and_fill = (pass_id, index_id) => {
    api
      .get(`/transactions/member/account/inasso/${pass_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        const filteredData = response.data.data.map((item) => ({
          index: index_id,
          account_name: item.account_name,
          account_id: item.id,
          stamp_value: item.stamp_value,
          current_balance: item.current_balance,
        }));

        if (accounts_data.length > 0) {
          setAccounts_data([...accounts_data, ...filteredData]);
        } else {
          setAccounts_data(filteredData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const dynamicVariables = {};

  data.map((item, index) => {
    dynamicVariables[`this_accounts_${index}`] = [];
  });

  

  const refunds_accounts_fetch = () => {
    api
      .get(`/transactions/saving/groups/refund/things/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setRefund_data(response.data.data);
        setRefund_accounts_total(response.data.total);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    refunds_accounts_fetch();
  }, [id]);

  useEffect(() => {
    if (refund_data.length > 0) {
      // Step 1: Filter rows where original_amount > 0
      const validRows = refund_data.filter((row) => row.original_amount > 0);
  
      // Step 2: Extract valid accounts from valid rows
      const allAccounts = validRows.flatMap((row) =>
        row.accounts_details
          .filter((item) => item.current_balance > 0) // Only include accounts with current_balance > 0
          .map((item) => ({
            id: item.id,
            association_member_id: item.association_member_id,
          }))
      );
  
      // Step 3: Update refund_accounts state
      setRefund_accounts(allAccounts);
    }
  }, [refund_data]);

  const toggleRefundAccount = (item) => {
    setRefund_accounts((prevRefunds) => {
      const exists = prevRefunds.some(
        (account) =>
          account.id === item.id &&
          account.association_member_id === item.association_member_id
      );
      if (exists) {
        // Remove the account if it already exists
        setRefund_accounts_total((prevTotal) => prevTotal - item.current_balance);
        return prevRefunds.filter(
          (account) =>
            !(
              account.id === item.id &&
              account.association_member_id === item.association_member_id
            )
        );
      } else {
        // Add the account if it doesn't exist
        setRefund_accounts_total((prevTotal) => prevTotal + item.current_balance);
        return [
          ...prevRefunds,
          { id: item.id, association_member_id: item.association_member_id },
        ];
      }
    });
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        <Tabs
          value={value1}
          variant="scrollable"
          onChange={handleChange1}
          fullWidth={true}
          aria-label="basic tabs example"
        >
          <Tab
            label={
              <b
                style={{
                  fontStyle: "normal",
                  fontFamily:
                    "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                }}
              >
                Deposits
              </b>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <b
                style={{
                  fontStyle: "normal",
                  fontFamily:
                    "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                }}
              >
                Withdrawals/Refund
              </b>
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={value1} index={0}>
        <Box>
          <Typography
            variant="h4"
            sx={{ textAlign: "center" }}
            fontStyle="oblique"
          >
            Mass Deposit into Savings Accounts
          </Typography>
          <div style={{ display: "block" }}>
            <DateTimePicker
              id="date"
              name="date"
              label="Set date of transaction"
              value={date}
              onChange={(date) => setDate(date)}
              sx={{ m: 1 }}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
            />
            <div style={{ display: "flex" }}>
              <Typography
                sx={{ margin: "5px", color: "#003049" }}
                fontStyle="normal"
                variant="h6"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>Use stamps</b>
              </Typography>
              <Switch
                checked={checked}
                onChange={handleFormChange}
                sx={{ color: "#001845" }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
          </div>
          <form onSubmit={submit}>
            {formFields.map((form, index) => {
              accounts_data &&
                accounts_data.map((item) => {
                  if (item.index === form.index_id) {
                    dynamicVariables[`this_accounts_${form.index_id}`].push(
                      item
                    );
                  }
                });

              return (
                <div key={form.index_id}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Autocomplete
                      id="tags-outlined"
                      options={data}
                      sx={{ m: 1, width: 220 }}
                      getOptionLabel={(option) => option.passbook}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, value) =>
                        fetch_accounts_and_fill(
                          value.association_members_id,
                          form.index_id
                        )
                      }
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select member"
                          size="small"
                        />
                      )}
                    />
                    {Array.isArray(
                      dynamicVariables[`this_accounts_${form.index_id}`]
                    ) &&
                    dynamicVariables[`this_accounts_${form.index_id}`].length >
                      0 ? (
                      <Autocomplete
                        id="tags-outlined"
                        sx={{ m: 1, width: 220 }}
                        multiple
                        options={
                          dynamicVariables[`this_accounts_${form.index_id}`]
                        }
                        getOptionLabel={(option) => option.account_name}
                        isOptionEqualToValue={(option, value) =>
                          option.account_id === value.account_id
                        }
                        onChange={(event, values) => {
                          const updatedFormFields = formFields.map((item) => {
                            if (item.index_id === form.index_id) {
                              return {
                                ...item,
                                accounts: values.map((value) => ({
                                  account_id: value.account_id,
                                  account_name: value.account_name,
                                  stamp_value: value.stamp_value,
                                })),
                              };
                            }
                            return item;
                          });

                          setFormFields(updatedFormFields);
                        }}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Account"
                            size="small"
                            name="accounts"
                          />
                        )}
                      />
                    ) : null}
                    <Box sx={{ display: "block" }}>
                      {formFields[form.index_id]?.accounts?.map((account) => (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <TextField
                            size="small"
                            name="amount"
                            sx={{ m: 1 }}
                            label={`Amount for ${account.account_name}`}
                            onChange={(event) => {
                              const account_id = account.account_id;
                              const existingAmountIndex = formFields[
                                form.index_id
                              ].amount.findIndex(
                                (a) => a.account_id === account_id
                              );

                              if (existingAmountIndex !== -1) {
                                setFormFields((prevFormFields) => {
                                  const updatedFormFields = [...prevFormFields];
                                  updatedFormFields[form.index_id].amount[
                                    existingAmountIndex
                                  ].amount = event.target.value;
                                  return updatedFormFields;
                                });
                              } else {
                                const newAmountObject = {
                                  account_id: account_id,
                                  amount: event.target.value,
                                  amount_stamp: account.stamp_value
                                    ? account.stamp_value
                                    : 0,
                                };

                                setFormFields((prevFormFields) => {
                                  const updatedFormFields = [...prevFormFields];
                                  updatedFormFields[form.index_id].amount.push(
                                    newAmountObject
                                  );
                                  return updatedFormFields;
                                });
                              }
                            }}
                            value={
                              formFields[form.index_id]?.amount.find(
                                (a) => a.account_id === account.account_id
                              )?.amount || null
                            }
                          />
                          {checked === true ? (
                            <Chip
                              size="medium"
                              color="success"
                              label={
                                formFields[form.index_id]?.amount.find(
                                  (a) => a.account_id === account.account_id
                                )
                                  ? currencyFormat.format(
                                      account.stamp_value
                                        ? formFields[
                                            form.index_id
                                          ]?.amount.find(
                                            (a) =>
                                              a.account_id ===
                                              account.account_id
                                          )?.amount * account.stamp_value
                                        : formFields[
                                            form.index_id
                                          ]?.amount.find(
                                            (a) =>
                                              a.account_id ===
                                              account.account_id
                                          )?.amount
                                    )
                                  : currencyFormat.format(account.stamp_value)
                              }
                              sx={{ m: 1, mr: 5 }}
                            />
                          ) : null}
                        </div>
                      ))}
                    </Box>

                    <IconButton
                      disabled={formFields.length > 1 ? false : true}
                      onClick={() => removeField(form.index_id)}
                    >
                      <RemoveCircleIcon />
                    </IconButton>
                  </div>
                  <Divider variant="middle" />
                </div>
              );
            })}
            <div style={{ display: "flex", m: 1 }}>
              <Button
                sx={{ m: 1, backgroundColor: "#33415c", borderRadius: 4 }}
                size="small"
                onClick={addFields}
                variant="contained"
              >
                New Field
              </Button>
              <Button
                disabled={
                  formFields[0].amount[0]?.account_id || done === false
                    ? false
                    : true
                }
                sx={{ m: 1, borderRadius: 4 }}
                color="success"
                size="small"
                onClick={submit}
                variant="contained"
              >
                Deposit
              </Button>
            </div>
          </form>
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value1} index={1}>
        <Box>
          <Typography
            variant="h4"
            sx={{ textAlign: "center" }}
            fontStyle="oblique"
          >
            Mass Withdrawal/Refunds
          </Typography>
          <div style={{ display: "block" }}>
            <DateTimePicker
              id="date"
              name="date"
              label="Set date of transaction"
              value={date}
              onChange={(date) => setDate(date)}
              sx={{ m: 1 }}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
            />

            <div style={{ display: "flex" }}>
              <Typography
                sx={{ margin: "5px", color: "#003049" }}
                fontStyle="normal"
                variant="h6"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>Refunds/Withdrawal</b>
              </Typography>
              <Switch
                checked={checked_re}
                onChange={handleFormChange_re}
                sx={{ color: "#001845" }}
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
          </div>
            
          <div style={{ display: "flex", justifyContent:'space-between' }}>
            <Typography
              sx={{ margin: "5px", color: "#003049" }}
              fontStyle="normal"
              variant="h6"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Total Refunds/Withdrawal: {currencyFormat.format(refund_accounts_total)}</b>
            </Typography>

            <Box>
              <Chip
                size="medium"
                color="success"
                onClick={viewGroup}
                label="Open Form"
                sx={{ ml: 1,borderRadius: 3 }}
              />
             
             <Button
                size="large"
                color="success"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  m: 1,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                  },
                }}
                onClick={refund_now}
              >
                <b>Refund Cash</b>
              </Button>
            </Box>
          </div>
          <Box>
            <div>
              <Typography
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>Configurations</b>
              </Typography>

              <Box
                sx={{
                  overflowX: "auto",
                  maxHeight: 540,
                  overflowY: "auto",
                  "&::-webkit-scrollbar": {
                    width: "7px",
                    height: "7px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Passbook</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Member</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Accounts</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Outstanding loans</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Savings Total</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Total to be Refunded</b>
                        </Typography>{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {refund_data?.map((row) => (
                      <TableRow
                        key={row.transaction_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.passbook_number}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.member_name}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {row.accounts_details.map((item) => (
                                  <div style={{m:3}}>
                                    {item.account_name}:{" "}
                                    {currencyFormat.format(
                                      item.current_balance
                                    )}
                                      <Chip
                                        size="medium"
                                        color={
                                          refund_accounts.some(
                                            (item_1) =>
                                            item_1.id === item.id && item_1.association_member_id === item.association_member_id
                                          )
                                            ? "error"
                                            : "success"
                                        }
                                        label={
                                          refund_accounts.some(
                                            (item_1) =>
                                              item_1.id === item.id && item_1.association_member_id === item.association_member_id
                                          )
                                            ? "Withhold from list"
                                            : "Add to list"
                                        }
                                        disabled={item.current_balance <= 0 || row.original_amount <= 0}
                                        onClick={() => toggleRefundAccount(item)}
                                        sx={{ ml: 1 }}
                                      />
                                  </div>
                                ))}
                              </Box>
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {row.loan_details.map((item) => (
                                  <div style={{m:3}}>
                                    {item.account_name}:{" "}
                                    {currencyFormat.format(
                                      item.current_balance
                                    )}
                                  </div>
                                ))}
                              </Box>
                            </b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{currencyFormat.format(row.total_amount)}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{currencyFormat.format(row.original_amount)}</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </div>
          </Box>
          
         
        </Box>
      </CustomTabPanel>
    </LocalizationProvider>
  );
};

export default MassDeposit;
